// extracted by mini-css-extract-plugin
export var cmtNavMegaCard = "styles-module--cmt-nav-mega-card--6977c";
export var cmtNavMegaCard__cardContent = "styles-module--cmt-nav-mega-card__card-content--0576a";
export var cmtNavMegaCard__image = "styles-module--cmt-nav-mega-card__image--e9ea4";